module.exports = __webpack_public_path__ + "img/6.7869bbf9.png";